var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYandex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#FC3F1D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8095 11.246H21.9394C18.5108 11.246 16.71 12.9727 16.71 15.528C16.71 18.4288 17.9568 19.7755 20.5196 21.5022L22.632 22.918L16.5369 32H12L17.4719 23.8849C14.3203 21.6402 12.5541 19.4648 12.5541 15.7697C12.5541 11.1425 15.7749 7.99999 21.9048 7.99999H28V32H23.8095V11.246Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandex);
export default __webpack_public_path__ + "static/media/yandex.1ab6abfed6a687626f3348af9e345a53.svg";
export { ForwardRef as ReactComponent };